import { isEmpty } from 'lodash-es';
import { createContext, ReactElement, useContext, useEffect, useState } from 'react';
import {
  getCandidateInteractionPipelineResultCommSettings,
  PipelineResultCommSettings,
} from 'wisestep-api';

export const StatusActionPipelineContextNew = createContext<PipelineResultCommSettings | null>(
  null
);

interface StatusActionPipelineContextProviderProps {
  children: ReactElement;
}

export default function StatusActionPipelineContextProviderNew({
  children,
}: StatusActionPipelineContextProviderProps) {
  const [pipeline, setPipeline] = useState<PipelineResultCommSettings | undefined>();
  useEffect(() => {
    const DEFAULT = {
      pipelineData: [],
      communicationData: [],
      resultData: [],
      createdBy: 'DEFAULT',
      createdOn: Date.now().toString(),
      modifiedBy: 'DEFAULT',
      modifiedOn: Date.now().toString(),
      workspaceId: 'DEFAULT',
    };
    if (isEmpty(pipeline)) {
      (async function () {
        try {
          const req = await getCandidateInteractionPipelineResultCommSettings();
          if (!isEmpty(req.data)) {
            setPipeline(req.data);
          } else {
            setPipeline(DEFAULT);
          }
        } catch (e) {
          setPipeline(DEFAULT);
          console.log(e);
        }
      })();
    }
  }, [pipeline]);
  return (
    <>
      {pipeline && (
        <StatusActionPipelineContextNew.Provider value={{ ...pipeline }}>
          {children}
        </StatusActionPipelineContextNew.Provider>
      )}
    </>
  );
}

export function useStatusActionPipelineContextNew() {
  const context = useContext(StatusActionPipelineContextNew);
  if (!context) {
    throw new Error('useAppState must be used within the StatusActionPipelineContextProvider');
  }
  return context;
}
